import api from './api';
export var queryGuestMap = function (_a) {
    var queryKey = _a.queryKey;
    var data = queryKey[1];
    var sharingMapId = data.sharingMapId;
    return api.get("/guests/maps?sharingMapId=" + sharingMapId);
};
